module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M21.31,13.79l-3,9h-.12q-1.8-8.13-3.59-16.27h-.12c-.15.48-.31,1-.47,1.45Q12.69,12,11.41,16c-.22.69-.43,1.39-.63,2.09a.42.42,0,0,1-.51.38c-2.54-.08-5.09-.14-7.64-.2a.5.5,0,0,1-.43-.25C-2.25,11.68.6,3.83,5.9,1.18,9.85-.79,13.6-.26,17,2.67c.39.33.59.35,1,0,3.39-2.91,7.14-3.51,11-1.51S34.92,6.75,35,11.47a11.44,11.44,0,0,1-2,6.46.66.66,0,0,1-.67.29c-2.62,0-5.24-.09-7.86,0a1.45,1.45,0,0,1-1.66-1.15C22.37,16,21.83,14.94,21.31,13.79Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M3.57,19.56c.89.1,1.78.07,2.68.09,1.62,0,3.24.08,4.86.14.29,0,.4-.14.48-.39.23-.69.45-1.38.67-2.08.65-2,1.29-4.05,1.93-6.07a2.32,2.32,0,0,1,.14-.32l3.61,16.31.09,0,3.42-10.18c.35.73.67,1.33.9,2a.57.57,0,0,0,.66.43l4.3,0c1.42,0,2.85,0,4.39,0a12.69,12.69,0,0,1-1.35,1.49q-6.23,6.88-12.44,13.78c-.35.38-.5.4-.85,0C13,30.07,9,25.44,4.82,21c-.43-.45-.88-.88-1.32-1.33Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cedea704","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/pulse.vue
// module id = 90835a71c844d517eb60
// module chunks = 89